import React from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useLocation } from 'react-use';
import { NextSeo } from 'next-seo';
import Layout from '@/components/Layout';
import Banner from '@/components/Chinese/Banner';
import Teacher from '@/components/Chinese/Teacher';
import LearningExperience from '@/components/Chinese/LearningExperience';
import PublicPraise from '@/components/Chinese/PublicPraise';
import Course from '@/components/Chinese/Course';
import PersonalCoach from '@/components/Chinese/PersonalCoach';
import Blog from '@/components/Chinese/Blog';
import Questions from '@/components/Chinese/Questions';
import CTA from '@/components/CTA';
import CoursePackage from '@/components/Chinese/CoursePackage';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'home', 'path', 'form', 'chinese'])),
    },
  };
};

const Chinese = () => {
  const { t } = useTranslation(['home', 'common', 'path', 'chinese']);
  const state = useLocation();
  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-中文课程-title'),
          description: t('common:seo-中文课程-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-中文课程-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-中文课程-title')}</title>
        <meta name="description" content={t('common:seo-中文课程-description')} />
        <meta name="keywords" content={t('common:seo-中文课程-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-中文课程-title')}
        />
      </Head>
      <main className="relative overflow-hidden">
        {/* pc 拆减两边 移动端铺满 */}
        <div className="absolute left-1/2 top-0 h-[758px] w-full translate-x-[-50%]  bg-[url('/images/home/bg-m.svg')] bg-cover  bg-center bg-no-repeat md:h-[4960px] md:w-[1920px] md:bg-[url('/images/chinese/chinese-bg.svg')]" />
        <div className="relative z-10 bg-transparent">
          <Banner />
          {/* 私教课 */}
          <PersonalCoach />
          {/* 最优秀的中文老师 */}
          <Teacher />
          {/* 分级课程 */}
          <Course />
          {/* 超越预期的学习体验 */}
          <LearningExperience />
          {/* 口碑之选 */}
          <PublicPraise />
          {/* 课包 */}
          <CoursePackage />
          {/* 博客 */}
          <Blog />
          <section className="marginModelTop">
            <CTA
              blockTitle="步骤之旅-标题"
              steps1name="步骤之旅-步骤-1"
              steps2name="步骤之旅-步骤-2"
              steps3name="步骤之旅-步骤-3"
              useTranslationName="chinese"
              subject="chinese"
            />
          </section>
          {/* 常见问题 */}
          <Questions />
        </div>
      </main>
    </>
  );
};

export default Chinese;

Chinese.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
